export default __webpack_public_path__ + "static/media/webinar.1c4e347c.svg";